<template>
  <div>
    <!-- <Top></Top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img :src="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">拼接屏</div>
          <div class="contentBottom">
            <div>互联网架构，突破视限的云端软拼方案</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div
      class="topText"
    > 与传统拼接方案完全不同，摒弃中央处理器环节，将拼接处理技术放在云端，极大的减少客户的硬件部署和内容管理成本。单个屏幕为输出单元，确保每块屏幕内容的高清展示。</div>

    <!-- start -->
    <!-- <div class="contentFlex">
      <div class="contentBox">
        <img :src="wawa1" alt>
      </div>
      <div class="contentBox">
        <img :src="wawa2" alt>
      </div>
      <div class="contentBox">
        <img :src="wawa3" alt>
      </div>
      <div class="contentBox">
        <img :src="wawa4" alt>
      </div>
    </div>-->
    <!-- end -->
    <!-- start -->
    <div class="titleBox">
      <div class="anliTitle">适用场景</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- iconFlex start -->
    <div class="iconParent">
      <div class="iconFlex">
        <div class="iconBox">
          <img :src="wawaIcon1" alt>
          <div class="iconText">影视娱乐</div>
        </div>
        <div class="iconBox">
          <img :src="wawaIcon2" alt>
          <div class="iconText">展厅展馆</div>
        </div>
        <div class="iconBox">
          <img :src="wawaIcon3" alt>
          <div class="iconText">商场卖场</div>
        </div>
        <div class="iconBox">
          <img :src="wawaIcon4" alt>
          <div class="iconText">企业大楼</div>
        </div>
        <div class="iconBox">
          <img :src="wawaIcon5" alt>
          <div class="iconText">门店</div>
        </div>
        <div class="iconBox">
          <img :src="wawaIcon6" alt>
          <div class="iconText">其他</div>
        </div>
      </div>
    </div>
    <!-- iconFlex end -->
    <!-- 产品特色 start -->
    <!-- start -->
    <div class="titleBox" style="margin-top:140px">
      <div class="anliTitle">产品特色</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <div class="teSeParent">
      <div class="teSeLeft">
        <img :src="teSeImg1" class="teSeImg" alt>
      </div>
      <div class="teSeRight">
        <div class="teSeTitle">百变拼接，自由切换</div>
        <div class="teSeText">每块屏幕都是独立播放单元，自定义联屏、局部拼、单屏内容及切换时序，创造更多广告价值，极大提高屏幕的利用效率。</div>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft teSeLeftTwo">
        <div class="teSeTitle">点对点传输，超高清展示</div>
        <div class="teSeText">每个屏幕为一个输出单元，云端服务器完成显示内容的分割处理，视频分割处理没有分辨率上限，确保分配给每一块屏幕的视频分辨率与硬件的分辨率一致。</div>
      </div>
      <div class="teSeRight teSeRightTwo">
        <img :src="teSeImg2" class="teSeImg" alt>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft">
        <img :src="teSeImg3" class="teSeImg" alt>
      </div>
      <div class="teSeRight">
        <div class="teSeTitle">标准外设，丰富交互体验</div>
        <div
          class="teSeText"
        >标准外设接口，可接入摄像头、蓝牙、NFC等多种感知外设，实现对人群属性、环境属性、商品属性、行为属性的采集；通过实时感知，实现丰富的感应交互方式，提供更多互动创意。
                        </div>
                        <div class="geryBottomText">
                            * 交互扩展功能，需配置传感设备及场景交互应用
                        </div>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft teSeLeftTwo">
        <div class="teSeTitle">全网总控，远程管理内容</div>
        <div class="teSeText"> 基于云的远程管控，从屏幕管理上极大地方便了运维团队。尤其适用于门店众多的连锁品牌，市场运维经理能够坐在办公室里统一管理分布于全国各地的屏幕。
                        </div>
                        <div class="geryBottomText">* 交互扩展功能，需配置传感设备及场景交互应用</div>
      </div>
      <div class="teSeRight teSeRightTwo">
        <img :src="teSeImg4" class="teSeImg" alt>
      </div>
    </div>
    <!-- 管理平台 start -->
    <!-- start -->
    <div class="titleBox marginTop142">
      <div class="anliTitle">管理平台</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="pingTaiFlex">
      <div class="pingtaiBox childImg">
        <img :src="adminImg1" alt>
      </div>
      <div class="pingtaiBox childImg">
        <img :src="adminImg3" alt>
      </div>
      <div class="pingtaiBox childImg">
        <img :src="adminImg2" alt>
      </div>
       <div class="pingtaiBox childImg">
        <img :src="adminImg4" alt>
      </div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="titleBox marginTop142">
      <div class="anliTitle">硬件选型</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="pingTaiFlex marginTop70 borderParent">
      <div class="pingtaiBox borderCss">
        <img :src="MPDPImgLeft4"  class="pingtaiBoxImg" alt>
        <!-- <div class="pingtaiBoxText">壁挂一体机</div> -->
      </div>
      <div class="pingtaiBox borderCss">
        <img :src="MPDPImgRight4" class="pingtaiBoxImg" alt>
        <!-- <div class="pingtaiBoxText">立式一体机</div> -->
      </div>
      <div class="pingtaiBox borderCss" >
        <img :src="storageBottom3" class="pingtaiBoxImg" alt>
        <!-- <div class="pingtaiBoxText">数拓盒子</div> -->
      </div>
      <div class="pingtaiBox" >
        <img :src="xuanXing4" class="pingtaiBoxImg" alt>
        <!-- <div class="pingtaiBoxText">数拓盒子</div> -->
      </div>
    </div>
    <!-- end -->
    <!-- 管理平台 end -->
    <!-- 产品特色 end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/MPDPImg.png";
import wawa1 from "@/assets/images/storage1.png";
import wawa2 from "@/assets/images/storage2.png";
import wawa3 from "@/assets/images/storage3.png";
import wawa4 from "@/assets/images/storage4.png";

import wawaIcon1 from "@/assets/images/mpdpIconTwo1.png";
import wawaIcon2 from "@/assets/images/mpdpIconTwo2.png";
import wawaIcon3 from "@/assets/images/mpdpIconTwo3.png";
import wawaIcon4 from "@/assets/images/mpdpIconTwo4.png";
import wawaIcon5 from "@/assets/images/mpdpIconTwo5.png";
import wawaIcon6 from "@/assets/images/mpdpIconTwo6.png";

import teSeImg1 from "@/assets/images/mpdpImgTwo1.png";
import teSeImg2 from "@/assets/images/mpdpImgTwo2.png";
import teSeImg3 from "@/assets/images/mpdpImgTwo3.png";
import teSeImg4 from "@/assets/images/mpdpImgTwo4.png";

import adminImg1 from "@/assets/images/mpdpBottom1.png";
import adminImg2 from "@/assets/images/mpdpBottom2.png";
import adminImg3 from "@/assets/images/mpdpBottom3.png";
import adminImg4 from "@/assets/images/mpdpBottom4.png";

import MPDPImgLeft4 from "@/assets/images/xuanXing1.png";
import MPDPImgRight4 from "@/assets/images/xuanXing2.png";
import storageBottom3 from "@/assets/images/xuanXing3.png";
import xuanXing4 from "@/assets/images/xuanXing4.png";


import storageBottom4 from "@/assets/images/storageBottom4.png";
import Bread from "@/components/bread.vue";
export default {
  name: "ProductMPDPTwo",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      toBreadChild: ["产品", "星辰云货架"],
      bgImg: bgImg,
      wawa1: wawa1,
      wawa2: wawa2,
      wawa3: wawa3,
      wawa4: wawa4,
      wawaIcon1: wawaIcon1,
      wawaIcon2: wawaIcon2,
      wawaIcon3: wawaIcon3,
      wawaIcon4: wawaIcon4,
      wawaIcon5: wawaIcon5,
      wawaIcon6: wawaIcon6,
      storageBottom3: storageBottom3,
      storageBottom4: storageBottom4,
      teSeImg1: teSeImg1,
      teSeImg2: teSeImg2,
      teSeImg3: teSeImg3,
      teSeImg4: teSeImg4,
      xuanXing4: xuanXing4,
      adminImg1: adminImg1,
      adminImg2: adminImg2,
      adminImg3: adminImg3,
      adminImg4: adminImg4,
      MPDPImgLeft4: MPDPImgLeft4,
      MPDPImgRight4: MPDPImgRight4
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
.topText {
  width: 60%;
  margin: auto;
  max-width: 890px;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 74px;
  margin-bottom: 80px;
}

/* start */
.anliTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}
.geryBottomText{
  color: #999;
  font-size: 2rem;
  margin-top: 4px;
}
.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 179px;
}

/* end */
.contentFlex {
  width: 80%;
  margin: auto;
  display: flex;
  justify-content: space-around;
}
.contentBox {
  width: 25%;
  text-align: center;
}
.contentBox img {
  width: 90%;
  max-width: 255px;
  margin: auto;
}
.iconParent {
  background: rgba(238, 238, 238, 1);
  margin-top: 56px;
}
.iconFlex {
  display: flex;
  width: 70%;
  margin: auto;
  padding: 84px 0 60px;
}
.iconBox {
  width: 33%;
  text-align: center;
}
.iconBox img {
 
}
.iconText {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 20px;
}
.teSeParent::after {
  content: "";
  display: block;
  clear: both;
}
.teSeParent {
  width: 70%;
  margin: auto;
  margin-top: 75px;
  
}
.teSeLeft {
  width: 50%;
  float: left;
}
.teSeRight {
  width: 42%;
  float: right;
}
.teSeImg {
  width: 100%;
  /* max-width: 769px;  */
}
.teSeTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  margin-top: 20%;
}
.teSeText {
  width: 90%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 5%;
  line-height: 30px;
}
.teSeLeftTwo {
  width: 42%;
  padding-left: 6.5%;
}
.pingtaiBoxImg{
  width: 100%;
}
.teSeRightTwo {
  width: 50%;
}
.imgBox {
  width: 70%;
  margin: auto;
}
.imgBox::after {
  content: "";
  display: block;
  clear: both;
}
.imgLeft {
  width: 49%;
  float: left;
}
.imgRight {
  width: 49%;
  float: right;
  text-align: right;
}
.imgXiaImg {
  width: 100%;
  max-width: 584px;
}
.marginTop2 {
  margin-top: 2%;
}
.spicial {
  background: #eeeeee;
  margin-top: 54px;
}
.positionBoxParent {
  position: relative;
}
.positionBox {
  position: absolute;
  bottom: 15px;
  text-align: center;
  width: 370px;
  left: calc(50% - 185px);
}
.positionTitle {
  font-size: 2.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 33px;
}
.positionText {
  font-size: 2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(106, 106, 106, 1);
}
.imgSmallImg {
  width: 80%;
  /* max-width: 481px; */
  margin-top: 49px;
}
.minimgBox {
  /* min-width: 886px; */
}
.pingTaiFlex {
  width: 70%;
  margin: auto;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.pingtaiBox {
  flex-grow: 1;
  text-align: center;
}
.childImg {
  width: 33%;
}
.childImg img {
  width: 94%;
}
.pingtaiBoxText {
  font-size: 2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}
.marginTop70 {
  margin-top: 70px;
}
.borderParent {
  border: 1px solid rgba(107, 107, 107, 1);
}
.borderCss {
  /* padding: 20px 0; */
  border-right: 1px solid rgba(107, 107, 107, 1);
}
</style>



// WEBPACK FOOTER //
// src/view/ProductMPDPTwo.vue